import { Box, Typography } from "@mui/material";
import React from "react";

const colorConf = {
    warning: {
        bgColor: "rgb(255, 244, 229)",
        textColor: "rgb(102, 60, 0)",
        iconColor: "rgb(237, 108, 2)",
    },
};

const Alert = ({ severity, children }) => {
    const colors = colorConf[severity]
        ? colorConf[severity]
        : {
            bgColor: "rgb(255, 244, 229)",
            textColor: "rgb(102, 60, 0)",
            iconColor: "rgb(237, 108, 2)",
        };
    return (
        <Box
            width={"100%"}
            borderRadius={"4px"}
            padding={"6px 16px"}
            display={"flex"}
            bgcolor={colors.bgColor}
            color={colors.textColor}
            style={{
                gap: "7px",
            }}
        >
            <Box color={colors.iconColor}>
                <svg
                    className="MuiSvgIcon-root MuiSvgIcon-fontSizeInherit css-1cw4hi4"
                    focusable="false"
                    aria-hidden="true"
                    viewBox="0 0 24 24"
                    data-testid="ReportProblemOutlinedIcon"
                >
                    <path d="M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"></path>
                </svg>
            </Box>
            <Box mb={"5.6px"}>
                <Typography style={{ fontWeight: "bold" }}>Warning</Typography>
                <Typography>{children}</Typography>
            </Box>
        </Box>
    );
};

export default Alert;
